import { AuthQuestionType, AuthQuestionValidationMethod } from '@/shared/types/node';

// Validation methods that match a substring/prefix/suffix of the ground truth.
const PARTIAL_MATCH_METHOD_LIST: AuthQuestionValidationMethod[] = [
  'contains',
  'starts_with',
  'ends_with',
];

// Question types whose answers are normalized/structured (not free text), so
// substring/prefix/suffix operators don't make sense for them.
const PARTIAL_MATCH_INCOMPATIBLE_TYPE_LIST: AuthQuestionType[] = [
  'date',
  'number',
  'phone',
  'email',
];

// Exposed as ReadonlySet<string> so both the Joi/Yup schema (which tests raw
// string input) and the panel (which tests typed values) can call `.has(...)`
// without casts. The typed lists above keep the set contents type-checked.
export const PARTIAL_MATCH_METHODS: ReadonlySet<string> = new Set(PARTIAL_MATCH_METHOD_LIST);
export const PARTIAL_MATCH_INCOMPATIBLE_TYPES: ReadonlySet<string> = new Set(
  PARTIAL_MATCH_INCOMPATIBLE_TYPE_LIST
);
